import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTelescope = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.407551 15.1299C-0.112127 14.2298 0.144257 13.0817 0.997471 12.4881L17.0383 1.32917C17.9844 0.670995 19.2896 0.946595 19.8888 1.9311L22.7157 6.57539C23.3326 7.58886 22.9367 8.91345 21.8648 9.42213L4.10265 17.8517C3.16109 18.2985 2.03422 17.9474 1.51311 17.0448L0.407551 15.1299ZM5.67143 11.0639L13.5131 5.60874L16.3697 10.3697L7.65768 14.5042L5.67143 11.0639ZM4.4357 11.9235L1.85407 13.7195C1.64076 13.8679 1.57667 14.1549 1.70659 14.3799L2.81215 16.2948C2.94243 16.5205 3.22414 16.6082 3.45954 16.4965L6.29814 15.1494L4.4357 11.9235ZM17.7313 9.72348L14.7473 4.75019L17.8949 2.56053C18.1314 2.39599 18.4577 2.46488 18.6075 2.71101L21.4344 7.35531C21.5887 7.60867 21.4897 7.93982 21.2217 8.06699L17.7313 9.72348Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.1548 22.8704C17.5035 22.6469 17.6049 22.183 17.3813 21.8343L13.3813 15.5954C13.1801 15.2816 12.7789 15.1632 12.4396 15.3174L9.68957 16.5674C9.5597 16.6265 9.44937 16.7213 9.3715 16.8408L6.12155 21.8297C5.89547 22.1768 5.99354 22.6414 6.34061 22.8675C6.68769 23.0936 7.15233 22.9956 7.37842 22.6485L10.5091 17.8426L11.0196 17.6106V23.2502C11.0196 23.6644 11.3554 24.0002 11.7696 24.0002C12.1838 24.0002 12.5196 23.6644 12.5196 23.2502V17.0305L16.1186 22.6438C16.3422 22.9925 16.8061 23.094 17.1548 22.8704Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgTelescope;
